
import { Box, Typography } from "@mui/material";
import './families.css';

import Nutret from '../../../assets/images/100425_MarianWEB_Nutret.png';
import Zaks from '../../../assets/images/100425_MarianWEB_Zacks.png';
import Mili from '../../../assets/images/100425_MarianWEB_Mili.png';
//import Chunky from '../../../assets/images/Chunky_Home.png';
import Carousel from "../../../components/Carousel";

function Families() {
  return (
    <Box className="families-container">
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography className="families-title"
          sx={{
            color: "#E66671",
            fontWeight: "bold",
            textAlign: "center",
            fontFamily: "BloodOrange, sans-serif"
          }}
        >
          ✧ Familia Marián® ✧
        </Typography>
      </Box>
      <Box className="families-section">
          <Carousel customClass="families-slider" slidesToShow={4} images={[
            { src: Nutret, caption: "", route: "/submarcas/nutret" },
            { src: Zaks, caption: "", route: "/submarcas/zaks" },
            { src: Mili, caption: "", route: "/submarcas/mili" },
            //{ src: Chunky, caption: "" }
            ]} 
          />
      </Box>
    </Box>
  );
}

export default Families;